import {Component, OnInit, Inject, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import {MatSort} from '@angular/material/sort';
import {DateAdapter} from '@angular/material/core';
import {ErrorStateMatcher} from '@angular/material/core';
import {MatTableDataSource} from '@angular/material/table';
import {FormGroup, FormControl, FormGroupDirective, NgForm} from '@angular/forms';

import {ConfirmComponent} from 'src/app/shared/dialogs/confirm/confirm.component';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import {ActivityService} from 'src/app/services/activity.service';
import {TopicService} from 'src/app/services/topic.service';
import {DayService} from 'src/app/services/day.service';
import {AgendaService} from 'src/app/services/agenda.service';
import {SlotService} from 'src/app/services/slot.service';
import {Slot} from 'src/app/models/slot';
import {TopicSlotDialogComponent} from '../topic-slot-dialog/topic-slot-dialog.component';
import {Sponsor} from 'src/app/models/sponsor';
import {SponsorService} from 'src/app/services/sponsor.service';
import {MemberService} from 'src/app/services/member.service';
import {Agenda} from 'src/app/models/agenda';
import {EventStaffDialogComponent} from '../event-staff-dialog/event-staff-dialog.component';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-event-topic-dialog',
  templateUrl: './event-topic-dialog.component.html',
  styleUrls: [ './event-topic-dialog.component.scss' ],
  entryComponents: [
    ConfirmComponent
  ],
})
export class EventTopicDialogComponent implements OnInit {

  public Editor = ClassicEditor;
  public matcher = new FormErrorStateMatcher();

  public roleForm: FormGroup;
  public topicForm: FormGroup;

  public pdfForm: FormGroup;

  public displayedColumns: string[] = [ 'icon', 'name', 'date', 'edit', 'delete' ];

  public displayedPdfColumns: string[] = [ 'icon', 'name', 'download', 'delete' ];
  public displayedSlotsColumns: string[] = [ 'icon', 'name', 'slot_qtd', 'slot_used', 'wait_qtd', 'wait_used', 'edit', 'delete' ];

  public allSponsors: any[] = [];

  public dialogRef: any;

  //staff
  public displayedAgendaColumns: string[] = [ 'member_name', 'role_name', 'button_edit', 'button_delete' ];
  public agendaTopicNotes: Agenda[] = []
  public agendaTopicDataSource: MatTableDataSource<any>;

  //autocomplete
  public searchMemberControl: FormControl;
  public members: any[] = []
  public memberSelected: any;

  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor (
    public _agendaService: AgendaService,
    private _sponsorService: SponsorService,
    private dialog: MatDialog,
    public _dayService: DayService,
    public _activityService: ActivityService,
    public _topicService: TopicService,
    public _slotService: SlotService,
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DIALOG_DATA) public data: any) {

    this._topicService.currentEvent = this.data.event;
    console.log("this._topicService.currentEvent .control_ticket_by_topic: " + this._topicService.currentEvent.control_ticket_by_topic)
    this._topicService.currentDay = this.data.day;

    this._topicService.currentActivity = this.data.activity;
    this._topicService.currentTopic = this.data.topic;

  }

  ngOnInit () {
    this._adapter.setLocale('pt');
    this._topicService.setEdit()

    if (this._topicService.isEdit) {
      this._slotService.loadTopicSlots(this._topicService.currentEvent.id, this._topicService.currentTopic.id);
    }

    this.topicForm = this._topicService.createForm(this._topicService.currentTopic)
    this.roleForm = this._agendaService.createRoleForm();

    this._agendaService.loadRoles();

    this.pdfForm = this._activityService.createPdfForm();
    this._topicService.setPdfDataSource();

    if (this._topicService.currentTopic) {
      this.loadAgenda(this._topicService.currentTopic.id)
    }

    this.loadSponsors();

    //    this.initializeAutoCompletes();

  }

  loadAgenda (topic_id) {
    this._agendaService.loadAgendaTopic(topic_id)
      .subscribe((result) => {
        this.agendaTopicNotes = result.map(item => {
          return this._agendaService.makeNote(item.payload.doc)
        })
        this.agendaTopicNotes.sort(this._agendaService.compareStart)
        this.agendaTopicDataSource = new MatTableDataSource(this.agendaTopicNotes);
      })
  }

  insert () {
    if (this.topicForm.valid) {

      this._topicService.currentTopic = this.topicForm.value

      this._topicService.insert(this.topicForm.value)
        .then((res: any) => {
          // console.log(JSON.stringify(res))
          this._topicService.currentTopic.id = res;
        })
    }
  }

  update () {
    if (this.topicForm.valid) {
      let id = this._topicService.currentTopic.id
      this._topicService.update(id, this.topicForm.value)
    }
  }

  deleteTopic (element) {
    console.log("delete topic")
  }

  // MATERIAL /////////////////////////////
  uploadMaterial () {
    if (this._topicService.objectPdf) {
      this._topicService.uploadMaterial(this._topicService.objectPdf, this.pdfForm.value);
    }
  }

  selectFile (obj) {

    if (obj.target.files.length === 0)
      return;

    // var mimeType = obj.target.files[0].type;
    // if (mimeType.match('.pdf') == null) {
    //   this.snackBar.openSnackBar("Apenas arquivos PDF", '', 'info');
    //   return;
    // }

    this._topicService.objectPdf = obj.target.files[ 0 ];
    //  console.log("material name: " + obj.target.files[0].name)
    this.pdfForm.controls.original.setValue(obj.target.files[ 0 ].name);

  }

  removeMaterial (element) {
    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.name + "<br><br>Excluir este Material?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this._topicService.removeMaterial(this._topicService.currentTopic.id, element.id)
        /*
          .then(
            () => {
              this.snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (error) => { console.log("delete regional error: " + error.message) }
          )
          */
      }
    })
  }

  goToLink (url: string) {
    window.open(url, "_blank");
  }

  ////////////////////////////////////////////////////////


  openSlotDialog (element) {


    if (!element) {
      element = new Slot()

      element.event_id = this._topicService.currentEvent.id
      element.event_name = this._topicService.currentEvent.name

      element.topic_id = this._topicService.currentTopic.id
      element.topic_name = this._topicService.currentTopic.name
    }

    this.dialog.open(TopicSlotDialogComponent, {
      width: '840px',
      height: '530px',
      hasBackdrop: true,
      disableClose: true,
      panelClass: 'custom-dialog-container',
      data: element
    })

  }

  deleteSlot (element) {
    console.log(JSON.stringify(element.name))
  }

  loadSponsors () {

    this._sponsorService.select()
      .subscribe((result) => {

        this.allSponsors = result.map(item => {
          let entity = new Sponsor();
          entity.id = item.payload.doc.id;
          entity.name = item.payload.doc.data().name;
          entity.url = item.payload.doc.data().url;
          entity.image = item.payload.doc.data().image;
          return entity;
        });

      })

  }

  sponsorSelected (event) {

    let sponsor = this.allSponsors.find((e) => {
      return e.id == event
    })

    this.topicForm.controls.sponsor_name.setValue(sponsor.name);

  }

  updateBannerTopic () {

    if (this.topicForm.controls.sponsor_id.value) {

      const data_banner: any = {
        'topic_id': this._topicService.currentTopic.id,
        'sponsor_id': this.topicForm.controls.sponsor_id.value,
        'sponsor_name': this.topicForm.controls.sponsor_name.value,
        'file': this._topicService.objectBannerTopic
      }

      //  console.log("data_banner: " + JSON.stringify(data_banner))

      this._topicService.uploadBannerTopic(data_banner)

    }


  }

  ////////////////////////////////////////////////////////
  // STAFF DIALOG

  openStaffDialog (entity) {

    let data: any = {};

    if (entity) {
      data = entity;
    }

    let dialogRef = this.dialog.open(EventStaffDialogComponent, {
      width: '400px',
      height: '350px',
      hasBackdrop: true,
      disableClose: true,
      panelClass: 'custom-dialog-container',
      data: data
    });

    dialogRef.afterClosed()
      .subscribe(response => {
        if (!response) {
          return;
        }
        const actionType: string = response[ 0 ];
        const formData: FormGroup = response[ 1 ];
        const rawData = formData.getRawValue();
        const entity = this.makeNotesInAgenda(rawData);

        switch (actionType) {
          case 'insert':
            this._agendaService.insert(entity)
            break;
          case 'update':
            this._agendaService.update(entity)
            break;
        }

        this.loadAgenda(this._topicService.currentTopic.id);

      });
  }

  makeNotesInAgenda (rawData: any): any {

    const role = this._agendaService.roles.find((e) => {
      return e.id == rawData.role_id
    })

    const data = {
      'id': rawData.id,
      "member_id": rawData.member.id,
      "member_name": rawData.member.name,
      "member_state": rawData.member.state,
      "role_id": rawData.role_id,
      "role_name": role.name,
      "requireConfirm": rawData.requireConfirm,
      "requireSchedule": rawData.requireSchedule
    }

    const note = this._agendaService.createAgenda(
      "t",
      data,
      this._topicService.currentEvent,
      this._topicService.currentDay,
      this._topicService.currentActivity,
      this._topicService.currentTopic)

    return note;

  }

}
